import React from "react";
import { AwardsItemProps } from "..";
import "./_styles.scss";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

export default function LibCard({ data }: AwardsItemProps) {
  const { main_program, category } = data;

  return (
    securityService.checkRoleAccess(UserPermissions.viewAwards)?
    (
    <div className="card">
      <div className="name">{`${main_program}`}</div>
      <div className="desc">{`${category}`}</div>
    </div>
    ): (<div></div>)
  );
}
